import { render } from "./TextareaTypeComponent.vue?vue&type=template&id=c9f28c32&scoped=true"
import script from "./TextareaTypeComponent.vue?vue&type=script&lang=js"
export * from "./TextareaTypeComponent.vue?vue&type=script&lang=js"

import "./TextareaTypeComponent.vue?vue&type=style&index=0&id=c9f28c32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9f28c32"]])

export default __exports__